const departmentReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default departmentReducer;